import React, { useEffect } from "react";
// Default theme
import "@splidejs/react-splide/css";

// or other themes
import "@splidejs/react-splide/css/skyblue";
import "@splidejs/react-splide/css/sea-green";

// or only core styles
import "@splidejs/react-splide/css/core";

import "@splidejs/splide/dist/css/themes/splide-default.min.css";

function HeroPage() {
  useEffect(() => {
    // No need to create a new Splide instance and use .mount().
    // The Splide component handles it internally.
  }, []);
  return (
    <div className="pt-20">
      {/* <Splide
        options={{
          type: "loop", // Loop the slides.
          perPage: 1, // Number of slides to show at once.
          autoplay: true, // Enable auto-play.
          interval: 3000, // Set the interval between slides (in milliseconds).
        }}
      > */}
      {/* <SplideSlide>
          <section className="">
            <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
              <div className="mr-auto place-self-center lg:col-span-7 px-4 sm:px-6 md:px-8">
                <h1 className="text-center max-w-2xl mb-4 text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl xl:text-6xl">
                  <span className="text-blue-400 font-extrabold">መክሊት </span>
                  ግብረሰናይ{" "}
                  <span className="text-blue-400 font-extrabold">ድርጅት</span>
                </h1>
                <p className="max-w-2xl mb-6 font-semibold text-gray-500 sm:mb-8 sm:text-lg md:text-2xl text-center">
                  በእናንተ ደጋጎች እገዛ ለብዙዎች ጥቂት መክሊት እንሰጣለን ብዙ አትራፊ አገልጋዮችንም እናፈራለን
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                  <a
                    href="/join"
                    className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-white rounded-lg bg-blue-500 hover:bg-blue-400 focus:ring-4 focus:ring-blue-300 w-full sm:w-auto"
                  >
                    Join Us
                  </a>
                  <a
                    href="/contactus"
                    className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-blue-500 border border-blue-400 hover:text-white rounded-lg hover:bg-blue-500 focus:ring-4 focus:ring-gray-100 w-full sm:w-auto"
                  >
                    Contact us
                  </a>
                </div>
              </div>
              <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
                <img src="./image/senbet.png" alt="mockup" />
              </div>
            </div>
          </section>
        </SplideSlide> */}

      <section className="">
        <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="mr-auto place-self-center lg:col-span-7 px-4 sm:px-6 md:px-8">
            <h1 className="text-center max-w-2xl mb-4 text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl xl:text-6xl">
              <span className="text-blue-400 font-extrabold">Meklit </span>
              Humanitarian{" "}
              <span className="text-blue-400 font-extrabold">Association</span>
            </h1>
            <p className="max-w-2xl mb-6 font-semibold text-gray-500 sm:mb-8 sm:text-lg md:text-2xl text-center">
              In your kind support, we grant little talents to many and produce
              fruitful Youths.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="/join"
                className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-white rounded-lg bg-blue-500 hover:bg-blue-400 focus:ring-4 focus:ring-blue-300 w-full sm:w-auto"
              >
                Join Us
              </a>
              <a
                href="/contactus"
                className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-blue-500 border border-blue-400 hover:text-white rounded-lg hover:bg-blue-500 focus:ring-4 focus:ring-gray-100 w-full sm:w-auto"
              >
                Contact us
              </a>
            </div>
          </div>
          <div className="hidden lg:mt-0 lg:col-span-5 lg:flex">
            <img src="./image/1 png.png" alt="mockup" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default HeroPage;
